import React from 'react';
import PropTypes from 'prop-types';
import { LuArrowLeft } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

// DS
import { VertButton, VertContainer, Col } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Header/HeaderStyles.less';
import Icon from 'components/Atoms/Icons/Icon';

// HEADER DESKTOP COMPONENT
const HeaderCheckoutDesktop = ({ logo }) => {
  const navigate = useNavigate();

  /* Renders */
  return (
    <VertContainer
      fluid
      className="header-desktop-container  header-desktop-checkout-container"
    >
      <VertContainer className="vert-box-header" spacingX="regular">
        <div className="header-main-content">
          <div className="header-logo">
            <Link to={'/'} title="Ir para página inicial">
              <img src={logo} alt={`logotipo ${process.env.REACT_APP_TITLE}`} />
            </Link>
          </div>

          <div style={{ flex: 1 }} />
          <Col className="back-to-cart">
            <VertButton
              className="btn"
              type="link"
              spacing="small"
              icon={
                <Icon
                  className="icon"
                  size={`16px`}
                  component={LuArrowLeft}
                />
              }
              onClick={() => navigate(`/cart`)}
            >
              Voltar para o carrinho
            </VertButton>
          </Col>
        </div>
      </VertContainer>
    </VertContainer>
  );
};

HeaderCheckoutDesktop.propTypes = {
  logo: PropTypes.string.isRequired,
};

export default HeaderCheckoutDesktop;
